<template>
	<div>
		<!-- Output child page -->
		<router-view />

		<!-- Output navigation if we're not on child page -->
		<template v-if="$route.name == 'newsContainer'">
			<FilterableList
				v-if="items.length"
				:items="items"
				@itemClick="itemClick"
			/>
			<v-container v-else>
				<v-alert type="info">
					Ei uutisia
				</v-alert>
			</v-container>
		</template>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'NewsContainer',
	computed: {
		...mapState({
			items: state => state.news,
		}),
	},
	methods: {
		itemClick (item) {
			this.$router.push({ name: 'news', params: { pagename: item.name } })
		}
	},
	mounted () {
		this.$api.News.doRequest()
	}
};
</script>
